import script from "./CurrencyConverter.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyConverter.vue?vue&type=script&setup=true&lang=js"

import "./CurrencyConverter.vue?vue&type=style&index=0&id=1441dd9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1441dd9d"]])

export default __exports__